import React from "react";

const DiscoverAbasin = () => {
  return (
    <div>
      <div className="fintech-about-area pb-70">
        <div className="container mw-1320 position-relative z-1">
          <div className="saas-section-title text-center mw-full">
            <h2>
              <span>Discover how Abasin Express</span> streamlines business travel with seamless bookings, real-time updates, and cost-efficient solutions tailored for travel agencies and corporate needs.
            </h2>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="fintech-our-mission">
                <p>
Through continuous innovation and strong industry partnerships, we aim to expand globally and help travel businesses grow faster and more sustainably.
                </p>
                <div className="text-center">
                  <img
                    decoding="async"
                    src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon3.png"
                    alt="icon4"
                    className="om-icon"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="fintech-our-vision">
                <div className="text-end ov-img">
                  <img
                    decoding="async"
                    src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon4.png"
                    alt="icon4"
                  />
                </div>
                <h3>Our Vision</h3>
                <p>
To be a trusted global B2B flight platform, offering seamless and smart travel experiences through innovation and efficiency.



                </p>
              </div>
            </div>
            <div className="col-lg-12 col-xl-6">
              <div className="fintech-our-values">
                <h3>Our Benefits</h3>
                <div className="fintech-values-list">
                  <div className="fintech-values-card">
                    <div className="flex-shrink-0">
                      <img
                        decoding="async"
                        src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon5.png"
                        alt="icon5"
                      />
                    </div>
                    <p>
                      <span>Extensive Flight Search: </span> Access a wide range of domestic and international flights in one platform.


                    </p>
                  </div>
                  <div className="fintech-values-card">
                    <div className="flex-shrink-0">
                      <img
                        decoding="async"
                        src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon5.png"
                        alt="icon5"
                      />
                    </div>
                    <p>
                      <span>24/7 Support:</span>  Get round-the-clock assistance to ensure smooth and uninterrupted business operations.


                    </p>
                  </div>
                  <div className="fintech-values-card">
                    <div className="flex-shrink-0">
                      <img
                        decoding="async"
                        src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon5.png"
                        alt="icon5"
                      />
                    </div>
                    <p>
                      <span>Real-Time Updates:</span> Receive instant updates on flight availability, prices, and booking status.


                    </p>
                  </div>
                  <div className="fintech-values-card">
                    <div className="flex-shrink-0">
                      <img
                        decoding="async"
                        src="https://themes.envytheme.com/startp/wp-content/uploads/2025/01/icon5.png"
                        alt="icon5"
                      />
                    </div>
                    <p>
                      <span>Competitive Pricing:</span> Benefit from highly competitive fares to boost your profit margins.


                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscoverAbasin;
